export const TYPES_WITH_ELEVATED_LABEL = ['date', 'time', 'datetime-local'];

export const VALID_FALSY_VALUES = [0];
